import { useQuery } from '@tanstack/react-query';

import { brandsQueryOptions } from '../queries';

export function useBrands({ enabled } = { enabled: true }) {
  return useQuery({
    ...brandsQueryOptions(),
    enabled,
  });
}
